<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 27/9/2020
  -->

<template>
	<el-tabs
		ref="tabsElement"
		:key="instanceKey"
		v-model="activeTab"
		@tab-click="onTabClicked"
		:before-leave="beforeLeave"
		:tab-position="tabPosition">
		<el-tab-pane v-for="(tab, index) in tabs" :key="index"
					 :name="tab.name"
					 :label="tab.label"
					 :ref="tab.name"
					 lazy
					 :disabled="tab.disabled">
			<div v-if="isMobileScreen" class="w-100" :class="actionTabSelector">
				<slot name="tabAction" v-if="canShowActionsTab" :action="tabAction.action" :title="tabAction.title" :showsAsTab="false">
					<qw-button
						type="primary"
						class="w-100"
						@click="tabAction.action">
						{{tabAction.title}}
					</qw-button>
				</slot>

			</div>


			<slot :name="tab.name" :actionTabSelector="actionTabSelector">
				<component v-if="tab.component"
						   :is="tab.component"
						   :name="tab.name"
						   :ref="getTabContentRefId(tab.name)"
						   v-bind="{...attrsNoStylesClass, ...tab.params, actionTabSelector}"

						   class="tabbed-content fill-height"
				/>
				<router-view v-else
							 :name="tab.name"
							 :ref="getTabContentRefId(tab.name)"
							 v-bind="{...$attrs, ...tab.params, actionTabSelector}"

							 class="tabbed-content fill-height"
				/>
			</slot>
		</el-tab-pane>
		<el-tab-pane
			v-if="!isMobileScreen"
			name="tab-custom-actions"
			:disabled="true">
			<template #label>
				<div :class="actionTabSelector">
					<slot name="tabAction" v-if="canShowActionsTab" :action="tabAction.action" :title="tabAction.title" :showsAsTab="true">
						<qw-button
							type="primary"
							@click="tabAction.action">
							{{tabAction.title}}
						</qw-button>
					</slot>

				</div>
			</template>
		</el-tab-pane>

	</el-tabs>

</template>
<script>
import {delay, findParentComponent, getParentByTypeRecursive, numbersFromString, uuidv4} from "@/utils/helpers";
import { shallowRef } from 'vue';
import BaseComponent from "@/core/components/BaseComponent.vue";
import {ElTabPane} from '@patched-pkg/element-plus'
import {markRaw} from "vue";
import {isMobileScreen} from "@/core/screenHelper";

export default {
	extends: BaseComponent,
	name: "TabbedLayout",

	props: {
		tabs: {Array, default: () => []},
		paramTabName: {String, default: "activeTab"},
		routeName: [String, Function],
		syncUrl: {Boolean, default: true},
		keepAlive: Boolean,
		tabPosition: String,
		tabActionProvider: Function,
	},

	watch: {
		activeTab: function (newVal, oldVal) {
			console.log("TabbedLayout: activeTab changed: newVal = ", newVal, ", oldVal = ", oldVal)
			this.tabChanged = newVal !== oldVal
			this.openTab(this.activeTab)
		},
		tabs: function (){
			this.ensureInitialTab()
		}
	},
	data() {
		return {
			actionTabSelector: "tab-actions-"+uuidv4(),
			activeTab: null,
			removeWatcher: null,
			tabChanged: false,
			tabContentItems: {},
			tabAction: null,
			mq: window.matchMedia( "(min-width: 500px)" ),
			instanceKey: 0,
			mutationObserver: null,
		};
	},



	created() {
		this.makeTabsComponentsRaw()
	},

	mounted() {
		let watchParam = 'attrsComputed.' + this.paramTabName
		console.log("TabbedLayout.onParamTabChanged: watchParam = ", watchParam)
		if(this.syncUrl){
			this.removeWatcher = this.$watch(watchParam, this.onParamTabChanged, {immediate: true})
		} else {
			this.onParamTabChanged()
		}
		console.log("TabbedLayout: this.tabs = ", this.tabs)
		// this.ensureInitialTab()
		if(isMobileScreen()){
			this.resetTransformForMobile()
		}

	},


	// beforeUnmount() {
	unmounted(){
		console.log("TabbedLayout.unmounted")
		if(this.removeWatcher){
			this.removeWatcher()
		}
		if(this.mutationObserver){
			this.mutationObserver.disconnect()
		}
	},

	provide() {
		return {
			registerTab: this.registerTabInternal,
			unregisterTab: this.unregisterTabInternal,
		};
	},

	methods: {

		refreshTabs(){
			this.instanceKey++
		},

		resetTransformForMobile(){
			console.log("TabbedLayout.resetTransformForMobile: this.$refs.tabsElement = ", this.$refs.tabsElement)
			let element = this.$refs.tabsElement.$el.getElementsByClassName("el-tabs__nav")[0], bubbles = false;

			console.log("TabbedLayout.resetTransformForMobile: element = ", element)

			this.mutationObserver = new MutationObserver(function (mutations) {
				mutations.forEach(attrModified);
			});
			this.mutationObserver.observe(element, { attributes: true, subtree: bubbles });

			function attrModified(mutation) {
				let name = mutation.attributeName
				let newValue = mutation.target.getAttribute(name)
				let oldValue = mutation.oldValue;

				if (name === "style" && newValue.startsWith("transform: translateX") && newValue !== oldValue) {
					let value = numbersFromString(newValue)[0]
					mutation.target.style.transform = "translateX(0px)";
					if(value){
						console.log("TabbedLayout.resetTransformForMobile: scrollLeft = ", value);
						mutation.target.parentElement.scrollTo({
							left: -value + 50,//we scrolll a bit further to give a hint in case more tabs are hidden to the right
							behavior: 'smooth' // Optional: smooth scrolling
						});
					}
					console.log("TabbedLayout.resetTransformForMobile: numeric value = ", value);
				}
				console.log("TabbedLayout.resetTransformForMobile", name, newValue, oldValue);
			}
		},

		makeTabsComponentsRaw(){
			console.log("TabbedLayout.makeTabsComponentsRaw: this.tabs = ", this.tabs)
			if(this.tabs && this.tabs.length){
				for(let tab of this.tabs){
					if(tab.component){
						tab.component = markRaw(tab.component)
					}
				}
			}
		},

		registerTabInternal(component){
			console.log("TabbedLayout.registerTab123: component = ", component)
			let tabName = this.getTabNameByComponentContent(component)
			console.log("TabbedLayout.tabPaneName = ", tabName)
			this.tabContentItems[tabName] = component
			console.log("TabbedLayout.tabContentItems = ", this.tabContentItems)
		},
		unregisterTabInternal(component){
			console.log("TabbedLayout.unregisterTab: component = ", component.$options.name)
			let tabName = this.getTabNameByComponentContent(component)
			// delete this.tabContentItems[tabName]
		},
		getTabNameByComponentContent(component){
			let tabPane = getParentByTypeRecursive(component.$parent, ElTabPane)
			return tabPane.name
		},

		ensureInitialTab(){
			this.makeTabsComponentsRaw()
			console.log("TabbedLayout.ensureInitialTab: this.activeTab = " + this.activeTab, ", this.tabs = ", this.tabs)
			if (!this.activeTab && this.tabs[0]) {
				console.log("TabbedLayout.ensureInitialTab: set this.activeTab to ", this.tabs[0].name)
				this.activeTab = this.tabs[0].name
				if(!this.syncUrl){
					this.onParamTabChanged(this.activeTab)
				}
			}
		},

		getCurrentTabComponent() {
			console.log("TabbedLayout.getCurrentTabComponent: this.activeTab = ", this.activeTab)
			let tab = this.tabContentItems[this.activeTab]
			if(Array.isArray(tab)){
				tab = tab[0]
			}
			console.log("TabbedLayout.getCurrentTabComponent: tab1 = ", tab)
			if (!tab) {
				tab = this.$refs['tab_' + this.activeTab]
				console.log("TabbedLayout.getCurrentTabComponent: tab2 = ", tab)
				// let tabPane = this.$refs[this.activeTab]
				// console.log("getCurrentTabComponent: tabPane = ", tabPane)
				// if (Array.isArray(tabPane)) {
				// 	tabPane = tabPane[0]
				// }
				// console.log("getCurrentTabComponent: tabPane2 = ", tabPane)
				// console.log("getCurrentTabComponent: tabPane.$slots = ", tabPane.$slots)
				// tab = tabPane.$slots.default && tabPane.$slots.default()
				// console.log("getCurrentTabComponent: tab1 = ", tab)
				// if (Array.isArray(tab)) {
				// 	tab = tab[0].ctx.ctx
				// }
				// console.log("getCurrentTabComponent: tab2 = ", tab)
				// // tab = (tab || {}).componentInstance
				// // console.log("getCurrentTabComponent: tab3 = ", tab)
			}
			if (Array.isArray(tab)) {
				tab = tab[0]
			}
			return tab
		},

		switchTab(tabName) {
			let index = this.tabs.findIndex(tab => tab.name === tabName)
			if (index >= 0) {
				this.onParamTabChanged(this.tabs[0].name)
			}
		},

		async onParamTabChanged(val) {
			console.log("TabbedLayout.onParamTabChanged: attrs = ", this.$attrs, ", val = ", val, ", this.activeTab = ", this.activeTab, ", this.tabs = ", this.tabs)
			if((!val || val === "first-tab") && this.tabs && this.tabs[0]){
				val = this.tabs[0].name
				await this.openTab(val)
			}
			if(this.activeTab !== val){
				this.activeTab = val
				this.onTabChanged()
			}
		},

		// routeName(tabName){
		// 	throw "RouteName Not Implemented"
		// },

		// paramTabName(){
		// 	return "tabName"
		// },

		getTabContentRefId(name){
			return `tab_${name}`
		},

		onTabChanged() {
			this.$nextTick(async () => {
				await delay(10)
				console.log("TabbedLayout.onParamTabChanged: this.activeTab = ", this.activeTab, ", this.$refs = ", this.$refs)
				let tabs = this.$refs["tab_" + this.activeTab]
				let tabSlot = this.$slots[this.activeTab]
				console.log("TabbedLayout.onParamTabChanged: tabs = ", tabs)

				if(tabSlot){
					tabSlot = tabSlot()[0]
					console.log("TabbedLayout.tabSlot.onTabOpened22 3= ", tabSlot.$refs)
					console.log("TabbedLayout.tabSlot.onTabOpened22 = ", tabSlot.ctx)
				}
				// console.log("onParamTabChanged: this.$refs[this.activeTab] = ", tabs)
				// console.log("onParamTabChanged: tabSlot = ", tabSlot)
				let tab
				let tabItem = this.findActiveTabItem()
				if (tabs) {
					tab = tabs[0] || tabs
					console.log("TabbedLayout.onParamTabChanged: tab = ", tab)
					// tab = tab.$children[0]
				}
				this.onTabOpened(tabItem, tab)
				this.$emit("tabChanged", tabItem, tab)
			})
		},

		findActiveTabItem() {
			let index = this.tabs.findIndex(tab => tab.name === this.activeTab)
			if(index < 0) {
				index = 0
			}
			return this.tabs[index]
		},

		async onTabClicked(tab) {
			console.log("TabbedLayout.onTabClicked: tab.name = ", tab.name, ", this.activeTab = ", this.activeTab, ", this.tabChanged = ", this.tabChanged)
			if(this.tabChanged){
				this.onTabChanged()
				this.onTabClickedInternal(tab)
			}
		},

		onTabOpened(tab) {
			let path = this.getPath(tab.name)
			let eventName = "Tab opened"
			let _ = this.trackEvent(eventName, {title: tab.label, path: path})
			let tabContent = this.findTabContentByName(tab.name)
			console.log("TabbedLayout.onTabClicked: tabContent = ", tabContent)
			let tabAction = null
			if (tabContent){
				if(typeof tabContent.onTabOpened === "function") {
					tabContent.onTabOpened()
				}
				if(typeof tabContent.tabAction === "function"){
					tabAction = tabContent.tabAction()
				}
			}
			if(!tabAction && this.tabActionProvider){
				tabAction = this.tabActionProvider()
			}
			this.tabAction = tabAction
		},

		onTabClickedInternal(tab) {
			let path = this.getPath(tab.name)
			// let _ = this.trackEvent(tab.label, {context: "Tab clicked", path: path})
			let tabContent = this.findTabContentByName(tab.name)
			console.log("TabbedLayout.onTabClickedInternal: tabContent = ", tabContent)
			if (tabContent && tabContent.onTabClicked && typeof tabContent.onTabClicked === "function") {
				tabContent.onTabClicked()
			}
		},

		findTabContentByName(tabName) {
			let tab = this.findTabComponent(this, tabName)
			console.log("TabbedLayout.findTabContentByName: tabName = ", tabName, ", tab = ", tab)
			return tab
			// if (tab) {
			// 	return tab.$children[0]
			// }
		},


		beforeLeave(activeName, oldActiveName) {
			// console.trace("beforeLeave: activeName = ", activeName, ", oldActiveName = ", oldActiveName)
			let tab = this.findTabContentByName(oldActiveName)
			console.log("TabbedLayout.beforeLeave: tab = ", tab, ", activeName = ", oldActiveName)
			return tab && tab.tabBeforeLeave ? tab.tabBeforeLeave(activeName, oldActiveName) : true
		},

		findTabComponent(component, name) {
			let ref = this.$refs[this.getTabContentRefId(name)]
			if(Array.isArray(ref)){
				ref = ref[0]
			}
			console.log("TabbedLayout.findTabComponent: ref = ", ref, ", name = ", name, ", this.$refs = ", this.$refs, ", this.getTabRefId(name) = ", this.getTabContentRefId(name))
			return ref
			// if (component.$options.componentName === "ElTabPane") {
			// 	return null
			// }
			// console.log("TabbedLayout.findTabComponent: component = ", component, ", name = ", name)
			// console.trace("findTabComponent: component = trace ", component, ", name = ", name)
			// return walk(this, component => {
			// 	let child = component
			// 	let found = child.$options.componentName === "ElTabPane" && child.name === name
			// 	console.log("TabbedLayout.beforeLeave11: child.$options.componentName = ", child.$options.componentName, ", child.name = ", child.name)
			// 	let res = found ? child : this.findTabComponent(child, name)
			// 	if (res) {
			// 		return res
			// 	}
			// })
			// for (let i = 0; i < component.$children.length; ++i) {
			// 	let child = component.$children[i]
			// 	let found = child.$options.componentName === "ElTabPane" && child.name === name
			// 	// console.log("TabbedLayout.beforeLeave11: child.$options.componentName = ", child.$options.componentName, ", child.name = ", child.name)
			// 	let res = found ? child : this.findTabComponent(child, name)
			// 	if (res) {
			// 		return res
			// 	}
			// }
			// return null
		},

		findAllTabberComponents() {

			let tabberParents = []
			let tabber = findParentComponent(this, "TabbedLayout")
			while (tabber) {
				console.log("TabbedLayout.findAllTabberComponents: tabber = ", tabber)
				tabberParents.push(tabber)
				tabber = findParentComponent(tabber, "TabbedLayout")
			}
			return tabber
		},


		async openTab(tabName) {
			console.log("TabbedLayout.openTab: tabName = ", tabName)
			// let params = this.createTabParams(this, tabName) || {}
			// params[this.paramTabName] = tabName
			// // let routeName = this.routeName(tabName)
			// console.log("openTab: tabName = ", tabName)
			// // this.updatePathParams(params)
			// let routeName = this.routeName || this.$route.name
			// let path = this.getPath(tabName)
			// this.goPath(path)
			if (this.syncUrl) {
				let {name, params, query} = this.getRouteOptions(tabName)
				return this.goSync(name, params, query)
			}
		},

		getPath(tabName) {
			let options = this.getRouteOptions(tabName)
			let path = this.resolveRelativeSync(options)
			console.log("TabbedLayout getPath: tabName = ", tabName, ", options = ", options, ", path = ", path)
			return path
		},

		getRouteOptions(tabName) {
			let params = this.createTabParams(this, tabName) || {}
			console.log("TabbedLayout.getRouteOptions: this.$route = ", this.$route, ", this = ", this)
			params = {
				...this.$route.params,
				...params
			}
			params[this.paramTabName] = tabName
			let query = this.$route.query
			// let routeName = this.routeName(tabName)
			console.log("TabbedLayout.openTab: tabName = ", tabName, ", this.routeName = ", this.routeName)
			// this.updatePathParams(params)
			let routeName = this.routeName

			if (typeof this.routeName === "function") {
				routeName = this.routeName(params, query)
			}
			routeName = routeName || this.$route.name
			let options = {
				name: routeName,
				params,
				query: this.$route.query
			}
			return this.createRouteOptions(tabName, options)
		},

		createRouteOptions(tabName, options) {
			if (typeof this.$parent.createRouteOptions === "function") {
				return this.$parent.createRouteOptions(tabName, options)
			}
			return options
		},

		createTabParams(tabber, tabName) {
			// let components = this.findAllTabberComponents()
			let obj = {}
			if(!tabName || tabName === "first-tab"){
				obj.skipHistory = true
			}
			// for(tabber of components){
			// 	obj[tabber.paramTabName] = tabber.activeTab
			// }
			return obj
		},

	},

	computed: {


		attrsComputed() {
			return {...this.$attrs, ...this.$parent.$attrs}
		},

		shallowTabs(){
			return this.tabs.map(tab => {
				if(tab.component){
					let newTab = {
						...tab,
						component: shallowRef(tab.component),
					}
					tab = newTab
				}
				return tab
			})
		},

		canShowActionsTab(){
			return this.tabAction && this.tabAction.action && !this.tabAction.disableAction
		},

		isMobileScreen,


	},
}
</script>

<style lang="scss">

.el-tabs__nav-scroll{
	display: flex;
}
.el-tabs__nav{
	flex-grow: 1;
}
.el-tabs__item[aria-controls="pane-tab-custom-actions"]{
	cursor: inherit;
	flex-grow: 1;
	justify-content: right;
	&.is-disabled{
		color: inherit;
		cursor: inherit;
	}
}

.tabbed-content {
	//min-height: calc(100vh - 135px);
}
//::-webkit-scrollbar {
//	-webkit-appearance: none;
//	width: 7px;
//}
//
//::-webkit-scrollbar-thumb {
//	border-radius: 4px;
//	background-color: rgba(0, 0, 0, .5);
//	box-shadow: 0 0 1px rgba(255, 255, 255, .5);
//}
</style>

